import { render, staticRenderFns } from "./tit-wrap-secondary.vue?vue&type=template&id=72f19168&scoped=true&"
import script from "./tit-wrap-secondary.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f19168",
  null
  
)

export default component.exports